export enum NOTICE_CATEGORY {
  'COMMON' = 'COMMON',
  'K-ARAOKE' = 'K-ARAOKE',
  'BIXBY' = 'BIXBY',
}

export enum LANGUAGE {
  KO = 'ko',
  EN = 'en',
}
